import { message } from 'antd'
import { generateMessageError } from 'modules/core/utils'
import i18n from 'i18next'

export const onDownload = ({ downloadProcessFile, dataFile }) => {
  downloadProcessFile(dataFile.url_file, dataFile.name_file)
    .then(() => message.success(i18n.t('FEEDBACK_DOWNLOAD_FILE_SUCCESS'), 8))
    .catch((error) => message.error(generateMessageError(error, 'FEEDBACK_DOWNLOAD_FILE_ERROR'), 8))
}
